<template>
  <v-app light>
    <tool-bar @drawering="changeDrawerStatus()"></tool-bar>
    <div class="logo-content">
      <img src="./assets/logo.png" alt="logo" class="my-logo" @click="$router.push({name: 'home'})">
    </div>
    <drawer v-model="drawer" @click="drawer = false"></drawer>
    <router-view />

    <v-btn fab icon fixed bottom right class="wapp" color="green" dark href="https://wa.me/393490699160" target="_blank">
      <v-icon large>fab fa-whatsapp</v-icon>
    </v-btn>

    <v-footer class="success" height="50px">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <div class="white--text ml-3">
            <v-btn flat icon color="white" href="https://it-it.facebook.com/oblobb" target="_blank">
              <v-icon>fab fa-facebook</v-icon>
            </v-btn>
            <v-btn flat icon color="white" href="https://www.instagram.com/explore/tags/obl%C3%B3bbcatania/" target="_blank">
              <v-icon>fab fa-instagram</v-icon>
            </v-btn>
            <v-btn flat icon color="white">
              <v-icon>fab fa-twitter</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <div class="white--text mr-2">
        <v-icon small color="white">copyright</v-icon> <span class="hidden-xs-only">Copyright </span> <span>2020</span>
      </div>
    </v-footer>

    <cookie-law theme="royal" :message="$t('home.cookie')" button-text="OK"></cookie-law>
  </v-app>
</template>

<script>
/* eslint-disable */
import ToolBar from './components/ToolBar.vue';
import Drawer from './components/Drawer.vue';
import CookieLaw from 'vue-cookie-law';

export default {
  name: 'app',
  components: {
    ToolBar,
    Drawer,
    CookieLaw
  },
  data(){
    return{
      drawer: false
    }
  },
  methods: {
    changeDrawerStatus(){
      this.drawer = !this.drawer;
    }
  }
}
</script>

<style>
  .logo-content {
    margin: 0 auto;
    text-align: center;
  }

  .my-logo {
    width: 50%;
    padding: 5px;
    cursor: pointer;
  }

  .wapp {
    z-index: 999 !important;
    -webkit-box-shadow: 6px 4px 13px 0px rgba(0,0,0,0.75) !important;
    -moz-box-shadow: 6px 4px 13px 0px rgba(0,0,0,0.75) !important;
    box-shadow: 6px 4px 13px 0px rgba(0,0,0,0.75) !important;
  }
</style>
